module.exports = __webpack_public_path__ + "static/media/home.7d2327fd.svg";